/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ControlNotFoundError
 */
export interface ControlNotFoundError {
    /**
     * 
     * @type {number}
     * @memberof ControlNotFoundError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ControlNotFoundError
     */
    title: string;
    /**
     * 
     * @type {Message}
     * @memberof ControlNotFoundError
     */
    message: Message;
}

/**
 * Check if a given object implements the ControlNotFoundError interface.
 */
export function instanceOfControlNotFoundError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ControlNotFoundErrorFromJSON(json: any): ControlNotFoundError {
    return ControlNotFoundErrorFromJSONTyped(json, false);
}

export function ControlNotFoundErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlNotFoundError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': MessageFromJSON(json['message']),
    };
}

export function ControlNotFoundErrorToJSON(value?: ControlNotFoundError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': MessageToJSON(value.message),
    };
}

